import { resToImage } from "services/images";

import { Review } from "./types";

export const resToReview = (res: any): Review => {
  return {
    id: res.id,
    title: res.title ? res.title : "",
    metaDescription: res.metaDescription ?? "",
    metaTitle: res.metaTitle ?? "",
    slug: res.slug ?? "",
    content: res.content ?? "",
    image: res.image ? resToImage(res.image) : null,
    published: res.published ?? false,
    createdAt: res.createdAt ? new Date(res.createdAt) : new Date(),
    updatedAt: res.updatedAt ? new Date(res.updatedAt) : new Date(),
  };
};

export const reviewToBody = (data: Review): any => ({
  title: data.title,
  metaDescription: data.metaDescription,
  metaTitle: data.metaTitle,
  slug: data.slug,
  content: data.content,
  imageId: data.image?.id,
});
